// Angular
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

// Models
import { AppCleanup } from '../../models';

@Component({
	selector: 'sync-spinner',
	templateUrl: './sync-spinner.component.html',
	styleUrls: ['./sync-spinner.component.scss'],
})
export class SyncSpinnerComponent extends AppCleanup {
	@HostBinding('class') classes = 'component-container';

	@Input() spin: boolean = false;
	@Input() status: string;
	@Input() tooltip: string;

	@Output() onClick: EventEmitter<boolean> = new EventEmitter();

	buttonClicked() {
		this.onClick.emit();
	}
}
